enum FilePurpose {
    MANUAL = 'manual',
    USER_IMAGE = 'user_image',
    TASK_MESSAGE_ATTACHMENT = 'task_message_attachment',
    TASK_ATTACHMENT = 'task_attachment',
    BRAND_PROFILE_ASSET = 'brand_profile_asset',
    BRAND_PROFILE_IMAGE = 'brand_profile_image',
    TASK_CATEGORY_IMAGE = 'task_category_image',
    TASK_CATEGORY_ICON = 'task_category_icon',
    TASK_DELIVERABLE = 'task_deliverable',
    TASK_DELIVERABLE_PACK = 'task_deliverable_pack',
    PERK_IMAGE = 'perk_image',
    ILLUSTRATION_LIBRARY_ITEM = 'illustration_library_item',
    USER_NOTE_ATTACHMENT = 'user_note_attachment',
}

export default FilePurpose;
